import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

const Container = styled.div<{
  centerHorizontally: boolean;
  centerVertically: boolean;
  whiteBackground: boolean;
}>`
  display: flex;
  align-items: center;
  ${({ whiteBackground }) => whiteBackground && `color: ${COLORS.black};`}

  div:nth-child(2) {
    margin-left: 0.25rem;
  }

  ${({ centerHorizontally }) =>
    centerHorizontally && `justify-content: center;`}

  ${({ centerVertically }) =>
    centerVertically &&
    `
        height: 100%;
        align-items: center;
      `}
`;

const Icon = styled.div<{ whiteBackground: boolean }>`
  width: 1.5rem;
  min-width: 1.5rem;
  height: 1.5rem;
  min-height: 1.5rem;
  background-image: url(${({ whiteBackground }) =>
    whiteBackground
      ? "/images/gradient_loader-black.png"
      : "/images/gradient_loader.png"});
  background-repeat: no-repeat;
  background-size: contain;
  animation: rotate 1s infinite linear;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export { Icon, Container };
